import { IonModal } from '@ionic/react';
import styled from 'styled-components';

export const PaymentModalStyles = styled(IonModal)<{
  staticTheme: 'dark-violet' | 'domination' | 'purple-gradient' | undefined;
}>`
  body.dark & {
    ion-content {
      --background: linear-gradient(
        360deg,
        #2b0e21 0%,
        #14111e 49.18%,
        #1e0f34 100%
      );

      ${({ staticTheme }) =>
        staticTheme === 'dark-violet' &&
        `
        --background: #43285B;
      `}
    }
  }

  --border-radius: 28px 28px 0 0;

  ion-content {
    --background: #fff;

    &::part(scroll) {
      padding: 16px;
    }
  }
`;
